(function () {
	'use strict';
	angular.module('app.supplyChain')
	.controller('indirectPurchaseOrder', indirectPurchaseOrder);

	indirectPurchaseOrder.$inject = ['$scope',  '$timeout', '$rootScope', '$state', '$location', '$experiments', 'redirectParamsService',
		'leanFilterService', 'tableRenderService', 'tableService', 'storeService', 'FIRST_VIEW'];

	function indirectPurchaseOrder($scope, $timeout, $rootScope, $state, $location, $experiments, redirectParamsService,
			leanFilterService, tableRenderService, tableService, storeService, FIRST_VIEW) {
		var vm = this;
		var unsubscribe;

		// Set navigation properties
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}

		var waitForFilterLoad = ($location.search() && $location.search()['drilldown'] === '1' && $location.search()['supplierCode'] !== 'undefined');
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		vm.useReactReport = $experiments.isEnabled('react-indirect-purchase-orders');

		vm.showExcel = true;

		var rendererParams = {
			'multiFactory': true
		};
		var reportSettingsName = 'indirect-purchase-orders';
		var pinnedColumns = [];
		var defaultFilters = [];

		// Extra query params to send to backend in data requests
		var extraParams = [{
			excelReportName: 'IndirectPurchaseOrder'
		}];

		var extraFilters = [{
			'name': 'promiseDate',
			'type': 'range',
			'comparator': 'Between',
			'valueOne': 'startDate',
			'valueTwo': 'endDate'
		}, {
			'name': 'remainingQuantityFloat',
			'type': 'range',
			'comparator': 'Greater Than',
			'valueOne': 'onOrderQuantity'
		}, {
			'name': 'goldenSupplyDate',
			'type': 'range',
			'comparator': 'Less Than Or Equal To',
			'valueOne': 'nextDaysEnd'
		}, {
			'name': 'actualReceiptDate',
			'type': 'range',
			'comparator': 'Between',
			'valueOne': 'startDateARD',
			'valueTwo': 'endDateARD'
		}];
		// Set navigation properties

		var columns = [{
			'id': 'supplierName',
			'display': 'Supplier',
			'class': 'supplierCell',
			'width': 120
		}, {
			'id': 'factoryName',
			'display': 'Site',
			'width': 120
		}, {
			'id': 'indirectSpendCategory',
			'display': 'Indirect Spend Category',
			'class': 'supplierCell',
			'width': 200
		}].concat(showAssociatedItemCodeColumn() ? [{
			'id': 'associatedSpendItemCode',
			'display': 'Associated Item Code',
			'class': 'supplierCell',
			'width': 160
		}] : []).concat([{
			'id': 'purchaseDocumentType',
			'display': 'Purchase Document Type',
			'class': 'buyerCell',
			'width': 120
		}, {
			'id': 'erpOrderPolicy',
			'display': 'ERP Order Policy',
			'class': 'smallTextCell',
			'width': 120,
			'show': false
		}, {
			'id': 'orderDate',
			'display': 'Order Date',
			'class': 'dateCell',
			'width': 120,
			'renderer': tableRenderService.dateRenderer,
			'convertTimeZone': true,
			'title': 'The PO placement date.'
		}, {
			'id': 'goldenSupplyDate',
			'display': 'Expected Delivery Date',
			'class': 'dateCell',
			'width': 120,
			'renderer': tableRenderService.dateRenderer,
			'convertTimeZone': true,
			'title': 'The Requested Date for the PO.'
		}, {
			'id': 'reScheduleDate',
			'display': 'Rescheduled Date',
			'class': 'dateCell',
			'width': 120,
			'renderer': tableRenderService.dateRenderer,
			'convertTimeZone': true,
			'show': false
		}, {
			'id': 'promiseDate',
			'display': 'Supplier Commit Date',
			'class': 'dateCell',
			'width': 120,
			'renderer': tableRenderService.dateRenderer,
			'convertTimeZone': true,
			'sortDefaultReverse': true
		}, {
			'id': 'actualReceiptDate',
			'display': 'Actual Receipt Date',
			'class': 'dateCell',
			'width': 120,
			'renderer': tableRenderService.receivedDate,
			'convertTimeZone': true,
			'title': 'The date that the item was actually received'
		}, {
			'id': 'purchaseOrderNumber',
			'display': 'PO Number',
			'class': 'buyerCell',
			'width': 100
		}, {
			'id': 'purchaseOrderLine',
			'display': 'PO Line',
			'class': 'smallTextCell',
			'width': 60
		}, {
			'id': 'scheduleLine',
			'display': 'Schedule Line',
			'class': 'smallTextCell',
			'width': 130
		}, {
			'id': 'remainingQuantityFloat',
			'display': 'On Order Qty',
			'class': 'numberCell largeTitle alignRight',
			'width': 60,
			'renderer': tableRenderService.integer,
			'title': 'The open quantity that is currently awaiting delivery'
		}, {
			'id': 'totalOrderedQuantity',
			'display': 'Total Ordered Quantity',
			'class': 'numberCell veryLargeTitle alignRight',
			'width': 100,
			'renderer': tableRenderService.integer,
			'title': 'The original quantity that was ordered.'
		}, {
			'id': 'deliveredQuantity',
			'display': 'Delivered Quantity',
			'class': 'numberCell veryLargeTitle alignRight',
			'width': 100,
			'renderer': tableRenderService.integer,
			'title': 'The quantity that has been received'
		}, {
			'id': 'uom',
			'display': 'UOM',
			'class': 'smallTextCell',
			'width': 60
		}, {
			'id': 'POValue',
			'display': 'Open PO Value',
			'class': 'smallTextCell alignRight',
			'width': 150,
			'renderer': tableRenderService.currency,
			'title': 'The total value of the PO that has yet to be received.'
		}, {
			'id': 'fixedPOFlag',
			'display': 'Fixed Flag',
			'class': 'buyerCell',
			'width': 60
		}, {
			'id': 'unitPrice',
			'display': 'Unit Price',
			'class': 'buyerCell alignRight',
			'width': 120,
			'renderer': tableRenderService.currency,
			'keepAllDecimals': true
		}, {
			'id': 'poNotes',
			'display': 'Notes',
			'class': 'buyerCell',
			'width': 60
		}, {
			'id': 'poExceptionMsg',
			'display': 'ERP exception message',
			'class': 'buyerCell',
			'width': 100,
			'title': 'The ERP exception message taken from the system (move in, move out, cancel, etc).'
		}]);

		init();
		var meta = {
			reportSettingsName: reportSettingsName,
			reportSettingsId: reportSettingsId,
			reportName: 'Indirect purchase orders',
			reportUrl: '{0}/IndirectPurchaseOrderReport',
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'goldenSupplyDate',
			defaultSortDirection: 'desc',
			defaultFilters: defaultFilters,
			extraParams: extraParams,
			rendererParams: rendererParams,
			useBackendCurrencyConversion: true,
			pageSize: 50,
			searchType: 'item',
			specialPlaceholderText: 'Search categories...',
			extraFilters: extraFilters,
			setColumnDefaults: true,
			hasMandatoryFilters: globalConfig.user.role !== 'Supplier',
			waitForFilters: waitForFilterLoad
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;
		vm.reportName = 'Indirect purchase orders';

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = meta.reportName;

		$scope.baseReportName = vm.baseReportDisplay;

		vm.viewType = FIRST_VIEW.REPORTSETTINGSNAME_TO_VIEWTYPE[reportSettingsName] || '';

		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = meta.reportName;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: true, exportFileName: reportSettingsId ? vm.reportName : undefined});
		}

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				var factoryNdx = globalConfig.factory.id;
				if (response[0].deliveryEarlyDays !== undefined) {
					rendererParams.deliveryEarlyDays = response[0].deliveryEarlyDays[factoryNdx];
				}
				if (response[0].deliveryEarlyDaysInternational !== undefined) {
					rendererParams.deliveryEarlyDaysInternational = response[0].deliveryEarlyDaysInternational[factoryNdx];
				}
				if (response[0].deliveryGraceDays !== undefined) {
					rendererParams.deliveryGraceDays = response[0].deliveryGraceDays[factoryNdx];
				}
				return response;
			});
		}

		function showAssociatedItemCodeColumn() {
			return $experiments.isEnabled('premium-freight')
				&& globalConfig.user.role !== 'Supplier';
		}

		function init() {
			leanFilterService.clearFilters();
			leanFilterService.useFactoryFilter = globalConfig.user.role !== 'Supplier';
			if (globalConfig.user.role !== 'Supplier') {
				var supplierCodeFromUrl =  $location.search()['supplierCode'];
				var indirectSpendCategoryFromUrl = $location.search()['indirectSpendCategory'];

				defaultFilters = [{
					'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true
				},
				{
					'id': 'supplierNdx',
					'values': supplierCodeFromUrl ? [supplierCodeFromUrl] : [leanFilterService.leanDnaAllSelected]
				}];
				if (indirectSpendCategoryFromUrl) {
					defaultFilters.push({
						'id': 'indirectSpendCategory',
						'values': [indirectSpendCategoryFromUrl]
					});
				}
				var siteFilter = leanFilterService.filterDefinitions['Factory'];
				siteFilter.type = 'multiselect';
				siteFilter.removable = false;
				leanFilterService.setMasterFilterList([
					leanFilterService.filterDefinitions['BusinessUnit'],
					leanFilterService.filterDefinitions['Division'],
					leanFilterService.filterDefinitions['Entity'],
					siteFilter,
					leanFilterService.filterDefinitions['Supplier'],
					leanFilterService.filterDefinitions['MaterialGroup'],
					leanFilterService.filterDefinitions['IndirectSpendCategory']
				].concat(showAssociatedItemCodeColumn() ? [
					leanFilterService.filterDefinitions['AssociatedSpendItemCode']
				] : []).concat([
					leanFilterService.filterDefinitions['PurchaseDocumentType']
				]));
			} else {
				leanFilterService.setMasterFilterList([
					leanFilterService.filterDefinitions['PurchaseDocumentType']
				]);
			}
			leanFilterService.setMasterRangeFilterList([
				leanFilterService.filterDefinitions['OnOrderQty'],
				leanFilterService.filterDefinitions['OrderDate'],
				leanFilterService.filterDefinitions['DeliveryDate'],
				leanFilterService.filterDefinitions['PromiseDate'],
				leanFilterService.filterDefinitions['ActualReceiptDate']
			]);
			leanFilterService.setMasterStringFilterList([
				leanFilterService.filterDefinitions['PurchaseOrderNumber']
			]);
		}
	}
})();
